import { render, staticRenderFns } from "./VgArrowIcon.vue?vue&type=template&id=84b67afe&scoped=true&"
import script from "./VgArrowIcon.vue?vue&type=script&lang=js&"
export * from "./VgArrowIcon.vue?vue&type=script&lang=js&"
import style0 from "./VgArrowIcon.vue?vue&type=style&index=0&id=84b67afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b67afe",
  null
  
)

export default component.exports